export default __webpack_public_path__ + "static/media/sortingIconDescending.6fd65e28.svg";